export enum MovieTMDBSearchType {
	Edit = 'edit',
	Add = 'add'
}

export enum MovieType {
	Movie = 'movie',
	Inventory = 'inventory'
}
